const getRecentAnnouncements = async () => {
  return fetch("https://dealtunes-api.azurewebsites.net/api/RecentAnnouncements")
    .then((response) => response.text())
    .then((data) => JSON.parse(data));
};

export default getRecentAnnouncements;
